export default "__VITE_ASSET__1uup9q18__"